export { RoomDetailV2Connected as RoomDetailV2 } from './container';
